import React from "react";
import { RESTAURANT } from "@/data/restaurant";
import { ChevronRight, Utensils, CalendarRange } from "lucide-react";

/**
 * BookButton — opens OpenTable in a new tab. Use site-wide for "Book a Table" CTAs.
 * OrderButton — opens the online ordering page in a new tab.
 *
 * Both render as anchor tags so semantics are preserved for accessibility & analytics.
 */

export function BookButton({
  className = "btn-primary",
  children = "Book a Table",
  testid = "book-table-cta",
  showIcon = true,
}) {
  return (
    <a
      href={RESTAURANT.bookUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={className}
    >
      {children}
      {showIcon && <ChevronRight size={16} strokeWidth={1.5} />}
    </a>
  );
}

export function OrderButton({
  className = "btn-ghost-gold",
  children = "Order Now",
  testid = "order-now-cta",
  showIcon = true,
}) {
  return (
    <a
      href={RESTAURANT.orderUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={className}
    >
      {children}
      {showIcon && <Utensils size={15} strokeWidth={1.5} />}
    </a>
  );
}

export { CalendarRange };
